import React from 'react';
import styled from 'styled-components';
import { BodySmallMedium } from '../../../fonts/typography/Typography';
import { LayoutColors } from '@src/core/theme';
import { MdCheckCircleOutline } from 'react-icons/md';

interface ErrorMessageProps {
  text: string;
  style?: React.CSSProperties;
}
const ErrorMessage = ({ text, style }: ErrorMessageProps) => {
  return (
    <ErrorMessageStyles visible={!!text} style={style}>
      <MdCheckCircleOutline color={LayoutColors.errorDark} size={18} />
      <span>{text}</span>
    </ErrorMessageStyles>
  );
};

export default ErrorMessage;

interface ErrorMessageStylesProps {
  visible: boolean;
}
const ErrorMessageStyles = styled.div<ErrorMessageStylesProps>`
  ${BodySmallMedium}
  color: ${LayoutColors.errorDark};
  background: ${LayoutColors.errorLight};

  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  transition: all 0.1s ease-in;
  overflow: hidden;
  padding: ${(props) => (props.visible ? '8px' : '0px')};
  transform: ${(props) => (props.visible ? 'scaleY(1)' : 'scaleY(0)')};
  margin-bottom: ${(props) => (props.visible ? '16px' : '0px')};

  span {
    color: ${LayoutColors.errorDark};
  }
`;
